import Vue from 'vue'
import Vuex from 'vuex'
//- 控制开关,dev、test、prod
var ENV = process.env.VUE_APP_ENV;
Vue.use(Vuex);

// const buttonListReset = () => {
//   return {
//     //前后端共同维护
//     create: false,//创建
//     update: false,//更新
//     retrieve: false,//查询
//     delete: false,//删除
//     online: false,//未关联
//     offline: false,//关联
//     view: false,   //查看
//     verify: false, //验证
//     wrap: false,   //包装
//     replace: false,//替换
//     disassociate: false,//不相关  分离
//     copy: false,   //复制
//     revoke: false, //取消
//     expertComment: false,//专家打分
//     release: false,  //发布
//   }
// }

const state = {
  isWidth:'240px',
  showCollaspe:true,
  profileId:'',// 渠道档案渠道 用户id
  customerAppName: '',// 渠道档案渠道 渠道名称
  customerAppId: ENV == "prod" ? "345601" : "350201",// 渠道档案渠道 渠道id
  isChannelArchive: true, // 是否是渠道用户档案
  phone: false, // 融合档案渠道 用户的手机号
  profileInfo:'',//用户基础信息
  routerIndex:'',
  userId: "",
  detailUserItem: {
    sex: "男"
  },//查看个人的健康档案详情

  userName: '', //用户的账号
  appId: '326305', //应用id
  appName: '', // 应用id对应应用名称
  id: '', //账号id
  isSuperManager: false, //是否是超管  
  reviewStatu: false, //审核状态
  reportUrls: '', //当前编辑的报告图片数组
  roleManagerRefresh: false, //角色管理 是否刷新
  accountManagerRefresh: false, //账号管理  是否刷新
  customerManagerRefresh: false, //客户管理  是否刷新
  keepAlive: [],
  reviewIndex: -1,
};

const mutations = {
  SETBUTTONLIST(state, list) {
    state.buttonList = buttonListReset();
    state.buttonList = list;
  },
  resetWidth(state,list){
    state.isWidth=list
  },

  setKeepAlive: (state, keepAlive) => {
    state.keepAlive = keepAlive;
  }  
};

const getters = {
};

const actions = {
  setButtonList(store, param) {
    let buttonLists = store.state.buttonList;
    const buttonList = param.map((d) => {
      return d.buttonKey
    })
    for (let item in buttonLists) {
      if (buttonList.indexOf(item) !== -1) {
        buttonLists[item] = true
      }
    }
    store.commit('SETBUTTONLIST', buttonLists)
  }
}


export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters 
})
